import NFA from 'shared/helpers/analytics/NFAnalytics';
import {
  getUndefinedIfNotValid,
  pushRetinaDataInDatalayer,
} from 'shared/helpers/analytics/helpers';

// types
import { SearchPageLoadProps, PageLoadProps } from './types';

//constants
import { PLP_EVENTS } from 'shared/helpers/analytics/constants/plpEvents';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

export const onSearchPageLoad = ({ pagePayload, title }: SearchPageLoadProps) => {
  pushRetinaDataInDatalayer({ plpSearchTerm: title });

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: PLP_EVENTS.SEARCH_PAGELOAD,
    data: pagePayload,
  });
};

export const onOfferPageLoad = () => {
  NFA.firePageView();
};

export const onPageLoad = ({
  title,
  isBrand,
  params,
  pagePayload,
  categoryPageData,
}: PageLoadProps) => {
  pushRetinaDataInDatalayer({ plpCategoryId: params.categoryId, plpCategoryName: title });

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: PLP_EVENTS.CATEGORY_PAGELOAD,
    data: {
      ...pagePayload,
      ...categoryPageData,
      PLPId: params.id,
      isBrandListing: isBrand,
      categoryId: getUndefinedIfNotValid(params.categoryId) || params.id,
    },
  });
};
